module.exports = __webpack_public_path__ + "logo-tiendanube.9b67239a930f4742541abef6d541527c.png";